<template>
        <div id="map" style="width:620px;height:500px;"></div>
</template>

<script>
export default {
    mounted(){
       var map = new BMap.Map("map");    // 创建Map实例
        map.centerAndZoom(new BMap.Point(106.444707,29.549734), 20);  // 初始化地图,设置中心点坐标和地图级别
        //添加地图类型控件
        map.addControl(new BMap.MapTypeControl({
            mapTypes:[
                BMAP_NORMAL_MAP,
                BMAP_HYBRID_MAP
            ]
        }));
        map.setCurrentCity("");          // 设置地图显示的城市 此项是必须设置的
        map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
        var point = new BMap.Point(106.444366,29.549683);
        var opts = {
        position : point,    // 指定文本标注所在的地理位置
        offset   : new BMap.Size(-50, -50)    //设置文本偏移量
        }
        var label = new BMap.Label("重庆佳渝测绘有限公司，欢迎您！", opts);  // 创建文本标注对象
            label.setStyle({
                color : "red",
                fontSize : "12px",
                height : "20px",
                lineHeight : "20px",
                fontFamily:"微软雅黑"
            });
        map.addOverlay(label); 
    }
}
</script>